/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var XSquareIcon20Solid = forwardRef('XSquareIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 2a4 4 0 0 0-4 4v8a4 4 0 0 0 4 4h8a4 4 0 0 0 4-4V6a4 4 0 0 0-4-4H6Zm1.7 4.286a1 1 0 0 0-1.414 1.415L8.586 10l-2.3 2.3a1 1 0 1 0 1.415 1.414l2.299-2.3 2.3 2.3a1 1 0 1 0 1.414-1.415L11.414 10l2.3-2.3a1 1 0 0 0-1.415-1.414L10 8.586l-2.3-2.3Z" })));
});
